import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Status from "../../../../Componets/Status";
import ActionButton from "../../../../Componets/Buttons/action";
import Table from "../../../../Componets/Table";
import toast from "react-hot-toast";
import tables from "../../../../Data/Tables/Inventory/Sites/tables";
import headers from "../../../../Data/Tables/Inventory/Sites/headers";
import Loadercomponent from "../../../../Componets/Loader";
import { get_all_sites } from "../../../../Controllers/Inventory/Sites";

const SitesTable = () => {
    const [loader, setLoader] = useState(false);
    const [header, setHeader] = useState(headers);
    const [body, setBody] = useState();

    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalCount: 0,
        totalPages: 0,
    });

    const paginationdata = (data) => {
        let headerdata = {};
        header?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
        });
    };

    const formdata = (data) => {
        let page = data?.search ? pagination?.currentPage : 1;
        fetchData({
            ...data,
            currentPage: page,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const actiondata = (data) => {
        let headerdata = {};
        headers?.components?.map((value) => {
            headerdata[value.name] = value.value;
        });
        fetchData({
            ...data,
            search: headerdata?.search,
            sort: headerdata?.sort,
            status: headerdata?.status,
            currentPage: pagination?.currentPage,
            totalCount: pagination?.totalCount,
            totalPages: pagination?.totalPages,
        });
    };

    const fetchData = async (tabledata) => {
        try {
            setLoader(true);

            const params = {
                search: tabledata?.search,
                sort: tabledata?.sort,
                status: tabledata?.status,
                page: tabledata?.currentPage,
            };

            const sites = await get_all_sites(params);

            if (sites?.status) {
                let data = [];

                sites?.data?.map((value) => {
                    data.push({
                        Number: value?.number,
                        Name: value?.name,
                        Type: value?.type || "Site",
                        Manager: value?.manager,
                        Contact: value?.contact_number || "—",
                        Status: <Status status={value?.status} />,
                        Action: (
                            <ActionButton
                                edit={`/app/inventory/sites/edit/${value?._id}`}
                                id={value?._id}
                                api="delete-site"
                                actiondata={actiondata}
                                headers={header}
                            />
                        ),
                    });
                });

                setPagination({
                    currentPage: sites?.data?.currentPage,
                    totalCount: sites?.data?.totalCount,
                    totalPages: sites?.data?.totalPages,
                });

                setBody(data);
                setLoader(false);
            } else {
                toast?.error(sites?.message);
                setLoader(false);
            }
        } catch (errors) {
            toast?.error(errors?.message);
        }
    };

    const headerReset = () => {
        let componentData = [];
        headers?.components?.map((value) => {
            componentData.push({ ...value, value: null });
        });
        setHeader({ ...headers, components: componentData });
    };

    useEffect(() => {
        fetchData();
        headerReset();
    }, []);

    return (
        <Header headers={header} setHeaders={setHeader} formdata={formdata}>
            <Loadercomponent loader={loader}>
                <Table
                    head={tables}
                    body={body}
                    pagination={pagination}
                    paginationdata={paginationdata}
                />
            </Loadercomponent>
        </Header>
    );
};

export default SitesTable;